import React, { useEffect, useState } from "react";
import { FormElements } from "../../../../../../shared/bootstrap/form/FormElements";
import { useTemplateFormOxigen } from "./data/useTemplateFormOxigen";
import { useTranslation } from "react-i18next";
import { useTemplateFormOtherInfo } from "./data/useTemplateFormOtherInfo";
import { useParamsData } from "./data/useParamsData";
import { copyObject } from "../../../../../../shared/utils/objUtils";
import { useEffectOnlyUpdate } from "../../../../../../shared/utils/use_custom/useEffectCustom";
import InputCustom from "../../../../../../shared/bootstrap/form/input/InputCustom";
import FormGroup from "../../../../../../shared/bootstrap/form/form-group/FormGroup";
import { oxygenPlusConcentratorType } from "../../../../../../shared_lsi_sg/oxygenPlusConcentratorData";
import ConcentratorCorePortable from "./templateConcentratorCustom/core/ConcentratorCorePortable";
import ConcentratorCoreTransportable from "./templateConcentratorCustom/core/ConcentratorCoreTransportable";
import VoxiSudFooter from "./templateConcentratorCustom/VoxiSudFooter";

export function TemplateOxygenPlusConcentratorVoxiSud({ dataForm, changeValue, errors, setData, isSubmit }) {
  const { t } = useTranslation();
  const [sum, setSum] = useState();

  const {
    formStructurePathologies,
    formStructurePrescription,
    formStructureStroller
  } = useTemplateFormOxigen(t, dataForm);

  const {
    formStructureCannulaNasal, formStructureMask,
    formStructureDetailCannulaNasal, formStructureDetailMask
  } = useTemplateFormOtherInfo(t, dataForm);

  const { formStructureNote } = useParamsData(t, dataForm);

  // Tendina tipologia (prima riga, accanto a patologie) — senza validUntil
  const formStructureTipologia = [
    {
      name: "oxygenPlusConcentratorType",
      type: "select",
      label: `${t("oxygenPlusConcentrator.tipologia")}*`,
      options: [
        { label: t("oxygenPlusConcentrator.type.oxygen"), value: oxygenPlusConcentratorType.oxygen },
        { label: t("oxygenPlusConcentrator.type.oxygen_portable"), value: oxygenPlusConcentratorType.oxygen_portable },
        { label: t("oxygenPlusConcentrator.type.oxygen_transportable"), value: oxygenPlusConcentratorType.oxygen_transportable },
      ],
      dataElement: { type: "text" },
      col: { xs: "12", sm: "12", lg: "4", xl: "4" }
    }
  ];

  const formStructureNumeroSerbatoiAutorizzati = [
    {
      name: "numeroSerbatoiAutorizzati",
      type: "input",
      label: `${t("voxiSud.numeroSerbatoiAutorizzati")}*`,
      dataElement: {
        type: "number",
        min: 0
      },
      col: { xs: "12", sm: "12", lg: "4", xl: "4" }
    }
  ];

  const changeValueHandler = (data) => {
    if (data.name === "oxygenPlusConcentratorType") {
      const newType = data.value;
      const newData = { ...dataForm, oxygenPlusConcentratorType: newType };
      if (newType === oxygenPlusConcentratorType.oxygen) {
        Object.keys(newData).forEach((key) => {
          if (key.startsWith("portable.") || key.startsWith("transportable.")) {
            delete newData[key];
          }
        });
        delete newData.pulsedFlowSettings;
      } else if (newType === oxygenPlusConcentratorType.oxygen_portable) {
        Object.keys(newData).forEach((key) => {
          if (key.startsWith("transportable.")) {
            delete newData[key];
          }
        });
        delete newData.pulsedFlowSettings;
      } else if (newType === oxygenPlusConcentratorType.oxygen_transportable) {
        Object.keys(newData).forEach((key) => {
          if (key.startsWith("portable.")) {
            delete newData[key];
          }
        });
      }
      setData(newData);
      return;
    }
    changeValue && changeValue(data);
  };

  useEffectOnlyUpdate(() => {
    if (!dataForm?.cannulaNasal) {
      const modeField = formStructureDetailCannulaNasal.map((ele) => ele.name).join(",").split(",");
      const copyDataForm = copyObject(dataForm);
      modeField?.forEach((key) => { delete copyDataForm[key]; });
      setData(copyDataForm);
    }
  }, [dataForm?.cannulaNasal]);

  useEffect(() => {
    if (!dataForm?.mask) {
      const modeField = formStructureDetailMask.map((ele) => ele.name).join(",").split(",");
      const copyDataForm = copyObject(dataForm);
      modeField?.forEach((key) => { delete copyDataForm[key]; });
      setData(copyDataForm);
    }
  }, [dataForm?.mask]);

  const getValue = (val) => (val ? parseInt(val) : 0);
  useEffect(() => {
    setSum(
      getValue(dataForm?.nightFlowHourDie) +
      getValue(dataForm?.underStressFlowHourDie) +
      getValue(dataForm?.flowRestHourDie)
    );
  }, [dataForm?.nightFlowHourDie, dataForm?.underStressFlowHourDie, dataForm?.flowRestHourDie]);

  const selectedType = dataForm?.oxygenPlusConcentratorType;

  return (
    <>
      {/* Riga 1: patologie + tipologia (senza validità) */}
      <FormElements
        structure={[...formStructurePathologies, ...formStructureTipologia]}
        dataForm={dataForm}
        changeValue={changeValueHandler}
        errors={errors}
        isSubmit={isSubmit}
      />

      {/* Prescrizione ossigeno base — sempre visibile */}
      <p className={"title-paragraph"}>{t("sg.prescription")} | Ossigeno liquido</p>
      <FormElements
        structure={formStructurePrescription}
        dataForm={dataForm}
        changeValue={changeValueHandler}
        errors={errors}
        isSubmit={isSubmit}
      />

      <div className="row">
        <div className="col-sm-12 col-lg-3">
          <FormGroup
            label={{ label: t("prescription.template.check24h.label") }}
            error={{
              isVisible: sum > 24,
              message: t("prescription.template.check24h.error")
            }}
          >
            <InputCustom
              type={"text"}
              name={"check24h"}
              error={sum > 24}
              value={sum}
              disabled={true}
            />
          </FormGroup>
        </div>
      </div>

      {selectedType === oxygenPlusConcentratorType.oxygen_portable && (
        <ConcentratorCorePortable
          isSubmit={isSubmit}
          errors={errors}
          changeValue={changeValueHandler}
          dataForm={dataForm}
          setData={setData}
          prescriptionTitle="Portatile"
        />
      )}

      {selectedType === oxygenPlusConcentratorType.oxygen_transportable && (
        <ConcentratorCoreTransportable
          isSubmit={isSubmit}
          errors={errors}
          changeValue={changeValueHandler}
          dataForm={dataForm}
          setData={setData}
          prescriptionTitle="Trasportabile"
        />
      )}

      {/* Altre informazioni */}
      <p className={"title-paragraph"}>{t("sg.otherInfo")}</p>
      <FormElements
        structure={formStructureStroller}
        dataForm={dataForm}
        changeValue={changeValueHandler}
        errors={errors}
        isSubmit={isSubmit}
      />
      <FormElements
        structure={formStructureCannulaNasal}
        dataForm={dataForm}
        changeValue={changeValueHandler}
        errors={errors}
        isSubmit={isSubmit}
      />
      <FormElements
        structure={formStructureMask}
        dataForm={dataForm}
        changeValue={changeValueHandler}
        errors={errors}
        isSubmit={isSubmit}
      />
      <FormElements
        structure={formStructureNumeroSerbatoiAutorizzati}
        dataForm={dataForm}
        changeValue={changeValueHandler}
        errors={errors}
        isSubmit={isSubmit}
      />
      <FormElements
        structure={formStructureNote}
        dataForm={dataForm}
        changeValue={changeValueHandler}
        errors={errors}
        isSubmit={isSubmit}
      />

      {/* Blocco VoxiSud in fondo */}
      <VoxiSudFooter
        dataForm={dataForm}
        changeValue={changeValue}
        errors={errors}
        isSubmit={isSubmit}
      />
    </>
  );
}
